module.exports = __webpack_public_path__ + "static/fan-video-446c1765517bd5e9a71d6014d1cb8fb0.mp4";